import React from 'react';
import Section from '../../shared/reusables/Section';

const ExperienceSection = ({ experiences, language }) => {
    const title = language === 'en' ? 'Experience' : 'Ervaring';

    return (
        <Section title={title}>
            <div className="timeline">
                {experiences.map((exp, index) => (
                    <div key={index} className="timeline-item">
                        <div className="timeline-dot" />
                        <div className="timeline-content">
                            <div className="timeline-header">
                                <span className="timeline-title">{exp.title}</span>
                                <span className="timeline-period">{exp.period}</span>
                            </div>
                            <div className="timeline-company">{exp.company} · {exp.location}</div>
                            {exp.responsibilities?.length > 0 &&
                                exp.responsibilities[0] !== 'N/A' &&
                                exp.responsibilities[0] !== 'N.V.T.' && (
                                <ul className="timeline-list">
                                    {exp.responsibilities.map((r, i) => (
                                        <li key={i}>{r}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </Section>
    );
};

export default ExperienceSection;
